<div class="profile-container">
  <div class="">
    <div class="profile-content">
      <div class="row">
        <div class="col-lg-12 col-md-12 dataList" style="margin:0;padding: 0;">

          <div class="header-block" style="margin-bottom: 10px;">
            <div class="header-title">
              <app-breadcrumb></app-breadcrumb>
            </div>
          </div>

          <div class="header-block">
            <div class="header-title">
              <p>{{ 'ticket.title' | translate }} <span>{{ 'ticket.count' | translate }}: {{totalRecords}}</span></p>
            </div>
            <div class="add-block">



              <div class="filter-icon">
                <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshTickets()"></i>
              </div>
              <!-- <button><i class="bi bi-plus-lg"></i> Add</button> -->
            </div>
          </div>

          <!-- <div class="dataList-header">
                <div class="dataList-header-left">
                  <h4>TICKETS <span>Count: {{totalRecords}}</span></h4>
                </div>
                <div class="dataList-header-right">
                  <div class="filter-icon" *ngIf="downloadData.length != 0">
                    <i class="bi bi-file-earmark-medical" (click)="downLoad()"></i>
                  </div>
                  <select name="" id="" (change)="ticketStatusDropdownChange()" class="form-control" [(ngModel)]="status">
                    <option value="ALL">ALL</option>
                    <option value="OPEN">OPEN</option>
                    <option value="COMPLETED">COMPLETED</option>
                    <option value="CLOSED">CLOSED</option>
                    <option value="UNASSIGNED">UNASSIGNED</option>
                  </select>                        
                  <input type="text" style="margin-left: 10px" class="form-control" placeholder="Filter here" [(ngModel)]="searchFilter">
                  <div class="filter-icon">
                    <i class="bi bi-funnel" (click)="toggleFilter()"></i>
                    <i class="bi bi-arrow-clockwise" (click)="refreshTickets()"></i>
                  </div>
                </div>
                
              </div> -->
          <div style="display: flex;">
            <div class="dataList-content" [ngClass]="{'dataList-content-width': showFilter}">
              <table class="table">
                <thead>
                  <tr>
                    <th style="width: 5%;">{{ 'ticket.ticketId' | translate }}</th>
                    <th style="width: 15%;">{{ 'ticket.asset' | translate }}</th>
                    <th style="width: 20%;">{{ 'ticket.heading' | translate }}</th>
                    <th style="width: 20%;">{{ 'ticket.details' | translate }}</th>
                    <th style="width: 15%;">{{ 'ticket.latestTicketStatus' | translate }}</th>
                    <th style="width: 15%;">{{ 'ticket.ticketExpEndDate' | translate }}</th>
                    <th style="width: 10%;">{{ 'generic.action' | translate }}</th>
                  </tr>
                </thead>
              </table>

              <div class="ticket-block-data" id="{{ticket.id}}"
                [ngClass]="{ 'delete-highlight': ticket.ticket.ticketId == recordId }" *ngFor="let ticket of data | paginate : {
                    itemsPerPage: tableSize,
                    currentPage: pageNumber1,
                    totalItems: totalRecords
                    }">
                <div class="ticket-header-block">
                  <span style="width: 5%;padding: 8px;"
                    [ngClass]="{'ticket-id-color': ticket.ticket.ticketExpEndDate < toDayDate && ticket.ticket.latestTicketStatus == 'OPEN'}">{{ticket.ticket.ticketId}}
                    <i style="margin-left: 10px;" *ngIf="ticket.ticket.source == 'whatsapp'"
                      class="bi bi-whatsapp"></i></span>
                  <span style="width: 15%;padding: 8px;">
                    {{ticket.ticket.customerName || ' -- '}}
                  </span>
                  <span style="width: 20%;padding: 8px;">{{ticket.ticket.heading || ' -- '}}</span>
                  <span style="width: 20%;padding: 8px;" title="{{ticket.ticket.details}}">{{ticket.ticket.details || '
                    -- ' | slice:0:30}}</span>
                  <span style="width: 15%;padding: 8px;">{{ticket.ticket.latestTicketStatus || ' -- '}}</span>
                  <!-- <span style="width: 10%;padding: 8px;">{{ticket.ticket.customerType}}</span> -->

                  <span style="width: 15%;padding: 8px;"
                    [ngClass]="{'ticket-id-color': ticket.ticket.ticketExpEndDate < ticket.ticket.ticketExpStartDate && ticket.ticket.latestTicketStatus == 'OPEN'}">{{ticket.ticket.ticketExpEndDate
                    | date: 'mediumDate'}}</span>
                  <span style="width: 10%;padding: 8px;display: flex;justify-content: center;">

                    <i data-toggle="modal" title="View" (click)="getTicketTaskByID(ticket.ticket.ticketId)"
                      data-target="#ticketview" class="bi bi-eye-fill"></i>
                    <!-- <svg xmlns="http://www.w3.org/2000/svg" id="" title="View" style="margin: 0 10px" (click)="getTicketTaskByID(ticket.ticket.ticketId)" data-toggle="modal" data-target="#ticketview" *ngIf="actionControls.isView"  width="18" height="18" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
                          <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                          <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                        </svg>  -->
                    <i class="bi bi-plus-lg" style="margin: 0 10px" title="Add Task"
                      (click)="Ticketid(ticket.ticket.ticketId,ticket.ticket.details,ticket.ticket.heading)"
                      data-toggle="modal" data-target="#ticket"></i>
                    <!-- <svg xmlns="http://www.w3.org/2000/svg" title="Add Task" (click)="Ticketid(ticket.ticket.ticketId,ticket.ticket.details,ticket.ticket.heading)" data-toggle="modal" data-target="#ticket" width="16" height="16" fill="currentColor" class="bi bi-align-middle" viewBox="0 0 16 16">
                          <path d="M6 13a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v10zM1 8a.5.5 0 0 0 .5.5H6v-1H1.5A.5.5 0 0 0 1 8zm14 0a.5.5 0 0 1-.5.5H10v-1h4.5a.5.5 0 0 1 .5.5z"/>
                        </svg> -->
                    <i class="bi bi-trash" title="Delete" (click)="del(ticket.ticket.id,ticket)" data-toggle="modal"
                      data-target="#deleteModal" *ngIf="actionControls.isDelete"></i>
                  </span>
                </div>
                <div class="ticket-tasks-b row" *ngFor="let task of ticket.taskList;let t = index">
                  <div class="col-md-2 col-lg-2">
                    <label *ngIf="t == 0" for="">{{ 'task.ttaskId' | translate }}</label>
                    <p>{{task.tTaskId}}</p>
                  </div>
                  <div class="col-md-3 col-lg-3">
                    <label *ngIf="t == 0" for="">{{ 'task.name' | translate }}</label>
                    <p>{{task.name}}</p>

                  </div>
                  <div class="col-md-2 col-lg-2">
                    <label *ngIf="t == 0" for=""
                      [ngClass]="{'ticket-id-color': (task.assignedToUserName == '' || task.assignedToUserName == null) && ticket.ticket.latestTicketStatus == 'OPEN'}">Assigned
                      To </label>
                    <p>{{task.assignedToUserName}}</p>

                  </div>
                  <div class="col-md-3 col-lg-3">
                    <label *ngIf="t == 0" for="">{{ 'task.taskExpEndDate' | translate }}</label>
                    <p>{{task.taskExpEndDate | date : 'medium'}}</p>

                  </div>
                  <div class="col-md-2 col-lg-2">
                    <label *ngIf="t == 0" for="">{{ 'task.status' | translate }}</label>
                    <p style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                      title="{{task.latestTaskStatus}}">{{task.latestTaskStatus}}</p>

                  </div>
                </div>

              </div>
              <div class="loader" *ngIf="isLoading">
                <div class="spinner"></div>
              </div>
              <div class="pagination-block" *ngIf="data.length != 0">
                <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="onTableDataChange($event)">
                </pagination-controls>
              </div>
              <div style="display: flex;justify-content: center;align-items: center;height: 200px;">
                <h5 class="text-center" *ngIf="!isLoading && data.length == 0">no tickets</h5>
              </div>
            </div>
            <div class="filter-block" *ngIf="showFilter">
              <div class="filters">
                <div class="filter-title">
                  <p>Filters</p>
                  <div class="filter-apply-button">
                    <button (click)="resetFilter()">Reset</button>
                    <button (click)="applyFilter()">Apply</button>
                  </div>
                </div>
                <!-- <div class="single-filter form-group">
                      <label ><span><input name="filter" (click)="filterClicked('customerPhoneNoChecked')" type="radio"></span> Customer Phone No </label>
                      <input type="text" [(ngModel)]="customerPhoneNo" class="form-control">
                    </div> -->
                <div class="single-filter form-group">
                  <label><span><input name="filter" [checked]="selectedFilter === 'filterDateChecked'"
                        (click)="filterClicked('filterDateChecked')" type="radio"></span> Ticket Filter By Dates
                  </label>
                  <input type="date" [(ngModel)]="startDate" class="form-control">
                  <input type="date" [(ngModel)]="endDate" class="form-control">
                </div>
                <div class="single-filter form-group">
                  <label><span><input name="filter" [checked]="selectedFilter === 'filterStatusAndDateChecked'"
                        (click)="filterClicked('filterStatusAndDateChecked')" type="radio"></span> Ticket Filter By
                    Status and Dates </label>
                  <select name="" id="" class="form-control" [(ngModel)]="filterStatusDate">
                    <option value="OPEN">OPEN</option>
                    <option value="COMPLETED">COMPLETED</option>
                    <option value="CLOSED">CLOSED</option>
                    <option value="ASSIGNED">ASSIGNED</option>
                  </select>
                  <input type="date" [(ngModel)]="statusStartDate" class="form-control">
                  <input type="date" [(ngModel)]="statusEndDate" class="form-control">
                </div>
                <div class="single-filter form-group">
                  <label><span><input name="filter" [checked]="selectedFilter === 'filterByTicketIdChecked'"
                        (click)="filterClicked('filterByTicketIdChecked')" type="radio"></span> Filter By Ticket Id
                  </label>
                  <input type="text" [(ngModel)]="filterByTicketId" class="form-control">
                </div>

                <!-- <div class="single-filter form-group">
                      <label ><span><input name="filter" [checked]="selectedFilter === 'filterByTechnicianChecked'" (click)="filterClicked('filterByTechnicianChecked')" type="radio"></span> Filter By Technician </label>
                      <select name="" id="" class="form-control" [(ngModel)]="filterByTechnician">
                        <option value="{{user.userId}}" *ngFor="let user of usersWithoutCustomers">{{user.userName}}</option>
                      </select>
                    </div>  -->

                <!-- <div class="single-filter form-group">
                      <label ><span><input name="filter" (click)="filterClicked('filterByServiceTypeChecked')" type="radio"></span> Filter By Service Type </label>
                      <select name="" id="" class="form-control" [(ngModel)]="filterByServiceType">
                        <option [value]="service.name" *ngFor="let service of serviceData">{{service.name}}</option>
                      </select>
                    </div>  -->

                <div class="single-filter form-group">
                  <label><span><input name="filter" [checked]="selectedFilter === 'filterByticketPriorityChecked'"
                        (click)="filterClicked('filterByticketPriorityChecked')" type="radio"></span> Ticket Priority
                  </label>
                  <select name="" id="" class="form-control" [(ngModel)]="filterByticketPriority">
                    <option value="HIGH">High</option>
                    <option value="MEDIUM">Medium</option>
                    <option value="LOW">Low</option>
                  </select>
                </div>

                <div class="single-filter form-group">
                  <label><span><input name="filter"
                        [checked]="selectedFilter === 'filterByticketCompletedAndDatesChecked'"
                        (click)="filterClicked('filterByticketCompletedAndDatesChecked')" type="radio"></span> Completed
                  </label>
                  <select name="" id="" class="form-control" [(ngModel)]="filterByticketCompletedAndDates">
                    <option value="0">Any Time</option>
                    <option value="1">Last One Day</option>
                    <option value="2">Last Two Days</option>
                    <option value="3">Last Three Days</option>
                    <option value="7">Last One Week</option>
                    <option value="14">Last Two Weeks</option>
                    <option value="21">Last Three Weeks</option>
                    <option value="30">Last One Month</option>
                    <option value="60">Last Two Months</option>
                    <option value="90">Last Three Months</option>
                  </select>
                </div>

                <div class="single-filter form-group">
                  <label><span><input name="filter" [checked]="selectedFilter === 'filterByticketClosedAndDatesChecked'"
                        (click)="filterClicked('filterByticketClosedAndDatesChecked')" type="radio"></span> Closed
                  </label>
                  <select name="" id="" class="form-control" [(ngModel)]="filterByticketClosedAndDates">
                    <option value="0">Any Time</option>
                    <option value="1">Last One Day</option>
                    <option value="2">Last Two Days</option>
                    <option value="3">Last Three Days</option>
                    <option value="7">Last One Week</option>
                    <option value="14">Last Two Weeks</option>
                    <option value="21">Last Three Weeks</option>
                    <option value="30">Last One Month</option>
                    <option value="60">Last Two Months</option>
                    <option value="90">Last Three Months</option>
                  </select>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="addTicket" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'ticket.headings.add' | translate }}
          <span data-dismiss="modal">
            <i class="bi bi-x-lg" (click)="clearData()"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">

        <div [formGroup]="form">
          <div class="row ticket-form">
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>{{ 'ticket.ticketType' | translate }} <span class="required">*</span></label>
                <select class="form-control" formControlName="typeId">
                  <option value="" disabled selected hidden>---Select Type---</option>
                  <option *ngFor="let x of IDs" [value]="x.ticketTypeId">{{x.name}}</option>
                </select>
                <!-- <span class="err" *ngIf="form.get('typeId').invalid && formSubmit">ticket type required</span> -->

              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>{{ 'ticket.heading' | translate }} <span class="required">*</span></label>
                <input type="text" formControlName="heading" class="form-control">
                <!-- <span class="err" *ngIf="form.get('heading').invalid && formSubmit">subject required</span> -->
              </div>
            </div>

            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>{{ 'ticket.asset' | translate }} <span class="required">*</span></label>
                <select class="form-control" formControlName="customerName">
                  <option value="" selected disabled> -- select asset --</option>
                  <option value="{{list.objectInfoId}}" *ngFor="let list of objectInfoList">{{list.givenName}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>{{ 'ticket.endTime' | translate }} <span class="required">*</span></label>
                <input type="date" [min]="tomorrowDate" formControlName="endTime" class="form-control">
              </div>
            </div>
            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>{{ 'ticket.details' | translate }} <span class="required">*</span></label>
                <textarea name="" class="form-control" formControlName="details" style="height: 70px" id="" cols="10"
                  rows="5"></textarea>
                <!-- <span class="err" *ngIf="form.get('details').invalid && formSubmit">details required</span> -->
              </div>
            </div>


            <div class="col-lg-12" hidden="true">
              <label class="image-upload-container btn btn-bwm">
                <!-- <span>Select Image</span> -->
                <input #imageInput type="file" id="add-image-btn" accept="image/*" hidden="true"
                  (change)="onChange($event)">
              </label>
            </div>

            <div class="col-lg-12 media-content">
              <div class="mr-2 image-btn" (click)="addImageBtn()">
                <span>+ {{ 'ticket.add-image' | translate }}</span>
              </div>
              <div class="media-area"
                style="border: 1px solid #e5e5e5;border-radius: 5px;height: 80px;width: 100px;overflow: hidden;padding: 1px;"
                *ngFor="let image of images" class="mr-2">
                <img src="{{image}}" width="98px" height="78px" style="border-radius: 5px;" alt="" srcset="">
              </div>
            </div>
          </div>
        </div>


        <div class="modal-footer">
          <button type="button" id="closeModalButton6" (click)="clearData()" class="btn btn-secondary"
            data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
          <button type="button" (click)="addcontroller()" class="btn btn-primary">{{ 'ticket.headings.add' | translate
            }}</button>
        </div>
      </div>
    </div>
  </div>
</div>

<button id="view-ticket-button" data-toggle="modal" data-target="#ticketview" style="display: none;"></button>

<div class="modal fade" id="ticketview" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="task-content" *ngFor="let ticket of TicketData;">
        <div class="c-button">
          <div class="c-right">
            <span *ngIf="prevTicketId != ''" class="prev-ticket" (click)="prevTicket()"><i
                class="bi bi-arrow-left"></i></span>
            <h4>{{ 'ticket.ticket-Id' | translate }}: #{{ticket.ticketId}}</h4>
            <span *ngIf="nextTicketId != ''" class="next-ticket" (click)="nextTicket()"><i
                class="bi bi-arrow-right"></i></span>
            <!-- <div class="priority-block">
              <p (click)="priorityToggle()" class="priority">{{ticket.tpriority}}</p>
              <div class="priority-dropdown" [ngClass]="{'priority-dropdown-toggle': priority_dropdown_toggle}">
                <p (click)="updateTicketPriority(ticket.ticketId,'HIGH')">High</p>
                <p (click)="updateTicketPriority(ticket.ticketId,'MEDIUM')">Medium</p>
                <p (click)="updateTicketPriority(ticket.ticketId,'LOW')">Low</p>
              </div>
            </div> -->

            <!-- <div class="task-status-bar">
              <ul>
                <li class="activeStatus" (click)="activeStatus('All')" id="All">All</li>
                <li id="New">New</li>
                <li id="Completed">Completed</li>
                <li id="Pending">Pending</li>
                <li id="Canceled">Canceled</li>
              </ul>
            </div> -->
          </div>
          <div style="align-items: center;display: flex;">
            <!-- <input type="text" name="" id=""> -->
            <p *ngIf="ticket.source != '' && ticket.source != null" class="t-source">{{ 'ticket.source' | translate }}:
              {{ticket.source}}</p>
            <div class="priority-block">
              <p (click)="priorityToggle()" class="priority">{{ticket.tPriority}}</p>
              <div class="priority-dropdown" [ngClass]="{'priority-dropdown-toggle': priority_dropdown_toggle}">
                <p (click)="updateTicketPriority(ticket.ticketId,'HIGH')">High</p>
                <p (click)="updateTicketPriority(ticket.ticketId,'MEDIUM')">Medium</p>
                <p (click)="updateTicketPriority(ticket.ticketId,'LOW')">Low</p>
              </div>
            </div>
            <!-- <svg xmlns="http://www.w3.org/2000/svg" width="26" (click)="noteDropdown()" height="26" fill="currentColor" class="bi bi-journals" viewBox="0 0 16 16">
              <path d="M5 0h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2 2 2 0 0 1-2 2H3a2 2 0 0 1-2-2h1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1H1a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v9a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1H3a2 2 0 0 1 2-2"/>
              <path d="M1 6v-.5a.5.5 0 0 1 1 0V6h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V9h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 2.5v.5H.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1H2v-.5a.5.5 0 0 0-1 0"/>
            </svg>
            <svg data-toggle="modal" data-target="#taskAddModel" xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
              <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
            </svg> -->
            <!-- <svg (click)="insertConversation()" xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-chat-left-dots" viewBox="0 0 16 16">
              <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
              <path d="M5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
            </svg> -->
            <!-- <i class="bi bi-chat-dots" (click)="noteDropdown()" title="Chat"></i> -->
            <i class="bi bi-plus-circle" data-toggle="modal" data-target="#ticket" title="Add Task"></i>
            <i class="bi bi-x-lg" title="Close" (click)="cancelModel()"></i>
            <!-- <svg xmlns="http://www.w3.org/2000/svg" (click)="cancelModel()" style="margin-left: 10px" title="Close" data-dismiss="modal" width="26" height="26" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
              <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
            </svg> -->
          </div>
        </div>
        <div class="task-data">
          <ul class="task-header1">
            <li style="width: 20%;">{{ 'ticket.asset' | translate }} </li>
            <li style="width: 20%;">{{ 'ticket.customerType' | translate }}</li>
            <li style="width: 20%;">{{ 'ticket.heading' | translate }}</li>
            <!-- <li style="width: 25%;">Details	</li> -->

            <li style="width: 20%;">{{ 'ticket.status' | translate }}</li>
          </ul>
          <div class="task-table" style="margin-bottom: 10px;">
            <ul>
              <li style="width: 20%;">{{ticket.customerName || ' -- '}}</li>
              <li style="width: 20%;"><span
                  *ngIf="ticket.customerType != null && ticket.customerType != ''">{{ticket.customerType}}</span><span
                  *ngIf="ticket.customerType == null || ticket.customerType == ''">--</span></li>
              <li style="width: 20%;">{{ticket.heading || ' -- '}}</li>
              <!-- <li style="width: 25%;">{{ticket.details}}</li> -->

              <li style="width: 20%;text-align: center;position: relative;background-color: white;">
                <div>
                  <p><span (click)="statusDropdown()" style="cursor: pointer;padding: 5px 10px;"
                      class="NEW">{{ticket.latestTicketStatus}}</span></p>

                  <p><span *ngIf="ticket.latestTicketStatus == 'CLOSED' || ticket.latestTicketStatus == 'COMPLETED'"
                      (click)="reopenTicket(ticket.ticketId)" class="assignedToButton">{{ 'ticket.re-open' | translate
                      }}</span></p>

                </div>
              </li>
            </ul>
          </div>
          <div class="details">
            <div *ngIf="!ticketDetails_toggle">
              <span>{{ 'ticket.details' | translate }}</span> <span>: &nbsp;</span> <span>{{ticket.details || ' -- '}}<i
                  (click)="upDateTicketDetailsToggle()" class="bi bi-pencil-square"></i></span>
            </div>


            <div class="updateDetails" *ngIf="ticketDetails_toggle">
              <p>{{ 'ticket.updateDetails' | translate }}</p>
              <textarea name="" [(ngModel)]="updateDetails" id="" class="" cols="30" rows="3"></textarea>
              <div class="update-details-buttons">
                <button class="btn btn-danger" (click)="upDateTicketDetailsToggle()">{{ 'generic.cancel' | translate
                  }}</button>
                <button class="btn btn-primary" (click)="updateTicketDetails()">{{ 'generic.update' | translate
                  }}</button>
              </div>
            </div>
            <div>
              <span>{{ 'ticket.ticketExpEndDate' | translate }}</span> <span>: &nbsp;</span>
              <span>{{ticket.ticketExpEndDate | date:'medium'}}</span>
            </div>
          </div>


          <div class="assignedToAndTags">
            <!-- <div class="assignedTo">
            <p> <span>Assign to</span> <span *ngIf="ticket.assignedTo != null || ticket.assignedTo != ''">: {{ticket.assignedToUserName}}</span> 
                <span *ngIf="ticket.assignedTo == null || ticket.assignedTo == ''" (click)="addClass('assignedTo')" class="assignedToButton"> &nbsp; click here to assign</span>
                <span *ngIf="ticket.assignedTo != null && ticket.assignedTo != ''" (click)="addClass('assignedTo')" class="assignedToButton"> &nbsp; click here to reassign</span>
          </p>
          </div> -->
            <!-- <div class="usersTaged">
            <p *ngIf="task.tagUsers.length == 0"> <span>Users taged</span> <span class="assignedToButton" (click)="addClass('usersTaged')">: &nbsp; click here to Tag Users</span></p>
            <p *ngIf="task.tagUsers.length != 0"> <span>Users taged</span> <span *ngFor="let user of task.tagUsers;let u = index"> <span *ngIf="u == 0">: &nbsp;</span>  {{user.userName}},</span></p>
          </div> -->
          </div>
          <div class="assign-and-tag-data" id="assign-and-tag-data">
            <div class="assign-to-data">
              <div class="panel panel-default assign-panel" *ngIf="addClassType == 'assignedTo'">
                <div class="panel-heading">
                  <h3 class="panel-title">{{ 'ticket.assignTo' | translate }}</h3>
                  <input type="text" class="form-control" [(ngModel)]="assignInput" placeholder="search user">
                </div>
                <div class="panel-body">
                  <div *ngIf="ticket.assignedToUserName == '' || ticket.assignedToUserName == null">
                    <span *ngFor="let user of usersWithoutCustomers | filter: assignInput">
                      <p (click)="AssignToUser(ticket.ticketId,user.userId,'ASSIGNED',user.userName)">{{user.userName}}
                      </p>
                    </span>
                  </div>
                  <div *ngIf="ticket.assignedToUserName != ''">
                    <span *ngFor="let user of usersList | filter: assignInput">
                      <p (click)="AssignToUser(ticket.ticketId,user.userId,'REASSIGNED',user.userName)">
                        {{user.userName}}</p>
                    </span>
                  </div>
                </div>
              </div>
              <div class="panel panel-default usertags-panel" *ngIf="addClassType == 'usersTaged'">
                <div class="panel-heading">
                  <h3 class="panel-title">{{ 'ticket.tagUser' | translate }}</h3>
                </div>
                <div class="panel-body">
                  <div>
                    <span *ngFor="let user of usersList">
                      <p>{{user.userName}}</p>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="dropdown-data">
            <!-- <div class="status-content" *ngIf="statusNote">
            <textarea name="" style="height: 70px" [(ngModel)]="note" placeholder="enter status note" class="form-control" id="" cols="30" rows="10"></textarea>
            <select name="" id="" (change)="taskStatusDropdown()" [(ngModel)]="taskStatus">
              <option value="WORK_IN_PROGRESS">WORK_IN_PROGRESS</option>
              <option value="PENDING">PENDING</option>
              <option value="COMPLETED">COMPLETED</option>
              <option value="DEFERRED">DEFERRED</option>
              <option value="PARTIALLY_COMPLETED">PARTIALLY_COMPLETED</option>
              <option value="FORCE_CLOSED">FORCE_CLOSED</option>
              <option value="CLOSED">CLOSED</option>
            </select>
            <button (click)="updateStatus(task.id)">update status</button>
          </div> -->

            <div class="dropdown-data statusDrop" id="dropN">
              <div class="status-content">
                <p>{{ 'ticket.chat' | translate }}</p>
                <textarea name="" [(ngModel)]="tnotes" placeholder="enter chat" id="" cols="30" rows="3"></textarea>

                <div hidden="true">
                  <input #imageInput type="file" id="add-note-image" accept="image/*" hidden="true"
                    (change)="onChangeAddNoteImage($event)">
                </div>

                <div class="note-image-view" *ngIf="NoteImage != ''">
                  <img src="{{NoteImage}}" alt="">
                  <button (click)="removeNoteImage()">{{ 'generic.remove' | translate }}</button>
                </div>


                <button *ngIf="NoteImage == ''" (click)="addNoteImage()" class="add-note-image">{{ 'ticket.add-image' |
                  translate }}</button>
                <div class="add-note-button">
                  <button class="btn btn-danger" (click)="noteDropdown()">{{ 'generic.cancel' | translate }}</button>

                  <button class="btn btn-primary" (click)="addNote()">{{ 'generic.send' | translate }}</button>
                </div>
              </div>
            </div>

            <div class="dropdown-data statusDrop" id="dropS">
              <div class="status-content">
                <p>{{ 'ticket.changeStatus' | translate }}</p>

                <textarea name="" [(ngModel)]="note" placeholder="enter status note" id="" cols="30"
                  rows="3"></textarea>

                <select style="width: 35%;" name="" (change)="ticketStatusDropdown()" [(ngModel)]="ticketStatus" id="">
                  <option value="COMPLETED">COMPLETED</option>
                  <option value="CLOSED">CLOSED</option>
                </select>
                <input *ngIf="ticketStatus == 'CLOSED'" [(ngModel)]="ticketClosingOtp" placeholder="enter otp"
                  type="text">


                <button class="btn btn-danger" (click)="statusDropdown()">{{ 'generic.cancel' | translate }}</button>
                <button class="btn btn-success" (click)="updateTicketStatus(ticketId)">{{ 'generic.update' | translate
                  }}</button>
              </div>
            </div>

            <div class="add-note-block" *ngIf="!addNoteShow">
              <button (click)="noteDropdown()"><i class="bi bi-chat-dots" title="Chat"></i>{{ 'ticket.chat' | translate
                }}</button>
            </div>

            <div class="status-table">
              <table class="table">
                <thead>
                  <tr>
                    <th style="width: 50%;">{{ 'ticket.note' | translate }}</th>
                    <th style="width: 20%;text-align: center;">{{ 'ticket.ticketStatus' | translate }}</th>
                    <th style="width: 30%;text-align: center;">{{ 'ticket.updatedDate' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let status of ticket.ticketStatus;">
                    <td style="width: 50%;">{{status.note}}</td>
                    <td style="width: 20%;text-align: center;">{{status.ticketStatus}}</td>
                    <!-- <td style="width: 15%;">{{status.updatedDate | date}}</td> -->
                    <td style="width: 30%;text-align: center;">{{status.updatedDate | date:'medium'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>



            <div class="status-table" *ngIf="ticket.tNotes != null && ticket.tNotes.length != 0">
              <table class="table">
                <thead>
                  <tr>
                    <th style="width: 45%;">{{ 'ticket.tNotes' | translate }}</th>
                    <th style="width: 5%;text-align: center;">{{ 'ticket.img' | translate }}</th>
                    <th style="width: 20%;text-align: center;">{{ 'ticket.userName' | translate }}</th>
                    <th style="width: 30%;text-align: center;">{{ 'ticket.date' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let tnotes of ticket.tNotes;">
                    <td style="width: 45%;">{{tnotes.note}}</td>
                    <td style="width: 5%;text-align: center;">
                      <!-- <i  *ngIf="tnotes.img" data-toggle="modal" (click)="imageView(tnotes.img)" data-target="#noteImageView" class="bi bi-image"></i> -->
                      <p-image *ngIf="tnotes.img" src="{{tnotes.img}}" alt="Image" height="20" width="20"
                        [preview]="true"></p-image>

                    </td>
                    <td style="width: 20%;text-align: center;">{{tnotes.userName}}</td>
                    <!-- <td style="width: 15%;">{{status.updatedDate | date}}</td> -->
                    <td style="width: 30%;text-align: center;">{{tnotes.date | date:'medium'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="image-container">
              <div class="image-header image-header1">
                <h5>{{ 'ticket.images-videos' | translate }}</h5>
                <i (click)="addTicketImageBtn()" class="bi bi-plus-circle"></i>
              </div>
              <div class="image-content-block">
                <div class="image-single" *ngFor="let image of ticket.image">
                  <img src="{{image}}" (click)="selectLargeImage(image)" alt="">
                </div>
                <div class="large-image-view" *ngIf="largeImage != ''">
                  <img src="{{largeImage}}" alt="">
                  <button (click)="selectLargeImage('')">{{ 'generic.close' | translate }}</button>
                </div>
                <!-- <div class="image-single" *ngFor="let video of task.video">
                <img src="assets/img/video-play-icon-hd-png.png" data-toggle="modal" data-target="#imageView" (click)="viewVideo(video)" alt="">
              </div> -->
              </div>

              <div hidden="true">
                <input #imageInput type="file" id="add-TicketImage-btn" accept="image/*" hidden="true"
                  (change)="onTicketChange($event)">
              </div>
            </div>

          </div>

          <ul class="task-header" *ngIf="TicketTaskdata != null && TicketTaskdata.length != 0">
            <li style="width: 9%;">{{ 'task.ttaskId' | translate }}</li>
            <li style="width: 9%;">{{ 'task.taskSlNo' | translate }}</li>
            <li>{{ 'task.completedPercentage' | translate }} %</li>
            <li>{{ 'task.createdDate' | translate }}</li>
            <li style="width: 20%;text-align: center;">{{ 'task.status' | translate }}</li>
            <li></li>
          </ul>



          <div class="task-table" *ngFor="let task of TicketTaskdata;let i = index">
            <ul>
              <li style="width: 9%;">#{{task.tTaskId}}</li>
              <li style="width: 9%;">{{task.taskSlNo}}</li>
              <li style="padding-left: 20px">{{task.completedPercentage}} %</li>
              <li>{{task.createdDate | date}}</li>
              <li style="width: 20%;text-align: center;">{{task.latestTaskStatus | titlecase}}</li>
              <li><a (click)="addc(i)"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                    fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                      d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
                  </svg></a></li>
            </ul>
            <div class="dropdown-data-show" id="{{i}}">
              <div class="assignedToAndTags">

                <div class="assignedTo">
                  <p>
                    <span>{{ 'task.assignTo' | translate }}</span>
                    <span *ngIf="task.assignedToUserName != null && task.assignedToUserName != ''">: &nbsp;
                      {{task.assignedToUserName}}</span>
                    <span *ngIf="task.assignedToUserName == null || task.assignedToUserName == ''"
                      (click)="taskSelected(task.taskId,'ASSIGNED')" data-toggle="modal" data-target="#assigntaskspopup"
                      class="assignedToButton"> &nbsp; click here to assign</span>
                    <span *ngIf="task.assignedToUserName != null && task.assignedToUserName != ''"
                      (click)="taskSelected(task.taskId,'REASSIGNED')" data-toggle="modal"
                      data-target="#assigntaskspopup" class="assignedToButton"> &nbsp; click here to reassign</span>
                  </p>
                </div>
                <!-- <div class="usersTaged">
                <p> <span>Users taged</span> <span *ngFor="let user of task.tagUsers;let u = index"> <span *ngIf="u == 0">: &nbsp;</span>  {{user.userName}},</span></p>
              </div> -->
              </div>
              <!-- <div class="dataTablesContent">
              <div class="left">
                <p><span>Listing number</span> <span>: &nbsp; {{task.taskListingNumber}}</span></p>
                <p><span>SI number</span> <span>: &nbsp; {{task.taskSINumber}}</span></p>
                <p><span>SL number</span> <span>: &nbsp; {{task.taskSlNo}}</span></p>
              </div>
              <div class="right">
                <p> <span>Reg id</span> <span>: &nbsp; {{task.taskRegId}}</span></p>
                <p> <span>Reg type</span> <span>: &nbsp; {{task.taskRegType}}</span></p>
              </div>
            </div> -->
              <p class="task-description"><span>{{ 'task.name' | translate }} :</span> {{task.name}}</p>

              <div class="details">
                <p *ngIf="!task.edit" class="task-description"><span>{{ 'task.description' | translate }} :</span>
                  {{task.description}} <i (click)="updateTaskDetailsToggle(i)" class="bi bi-pencil-square"></i></p>

                <div class="updateDetails" *ngIf="task.edit">
                  <p>{{ 'task.updateDescription' | translate }}</p>
                  <textarea name="" [(ngModel)]="task.eDescription" id="" class="" cols="30" rows="3"></textarea>
                  <div class="update-details-buttons">
                    <button class="btn btn-danger" (click)="updateTaskDetailsToggle(i)">{{ 'generic.cancel' | translate
                      }}</button>
                    <button class="btn btn-primary" (click)="updateTaskDescription(i,task.taskId)">{{ 'generic.update' |
                      translate }}</button>
                  </div>
                </div>
              </div>


              <div class="taskTable" style="padding: 0 10px;">
                <div>
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">{{ 'task.taskExpStartDate' | translate }}</th>
                        <th scope="col">{{ 'task.taskExpEndDate' | translate }}</th>
                        <th scope="col">{{ 'task.taskActStartDate' | translate }}</th>
                        <th scope="col">{{ 'task.taskActEndDate' | translate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td><span
                            *ngIf="task.taskExpStartDate != 0 && task.taskExpStartDate != null">{{task.taskExpStartDate
                            | date:'medium'}}</span><span
                            *ngIf="task.taskExpStartDate == 0 || task.taskExpStartDate == null">--</span></td>
                        <td><span *ngIf="task.taskExpEndDate != 0 && task.taskExpEndDate != null">{{task.taskExpEndDate
                            | date:'medium'}}</span><span
                            *ngIf="task.taskExpEndDate == 0 || task.taskExpEndDate == null">--</span></td>
                        <td><span
                            *ngIf="task.taskActStartDate != 0 && task.taskActStartDate != null">{{task.taskActStartDate
                            | date:'medium'}}</span><span
                            *ngIf="task.taskActStartDate == 0 || task.taskActStartDate == null">--</span></td>
                        <td><span *ngIf="task.taskActEndDate != 0 && task.taskActEndDate != null">{{task.taskActEndDate
                            | date:'medium'}}</span><span
                            *ngIf="task.taskActEndDate == 0 || task.taskActEndDate == null">--</span></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- <p class="task-description"><span>Note :</span> The lorem generator is nice but it’s code completing functionality makes it indispensable. Once you learn the syntax you can code a whole wireframe with just a few keystrokes.</p> -->

              <!-- <div class="taskTable">
              <div>
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Act duration</th>
                      <th scope="col">Act end date</th>
                      <th scope="col">Act start date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{task.taskActDuration | date}}</td>
                      <td>{{task.taskActEndDate | date}}</td>
                      <td>{{task.taskActStartDate | date}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div>
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Exp duration</th>
                      <th scope="col">Exp end date</th>
                      <th scope="col">Exp start date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{task.taskExpDuration | date}}</td>
                      <td>{{task.taskExpEndDate | date}}</td>
                      <td>{{task.taskExpStartDate | date}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div> -->


            </div>
          </div>
        </div>
      </div>

      <div class="ticket-list" *ngIf="prevTicketsList.length != 0">
        <h5 class="ticket-list-title">{{ 'ticket.title' | translate }}</h5>

        <div class="ticket" (click)="getTicketTaskByID(prevList.ticket.ticketId)"
          *ngFor="let prevList of prevTicketsList">
          <div class="form-group">
            <label for="">{{ 'ticket.ticketId' | translate }}</label>
            <p>{{prevList.ticket.ticketId}}</p>
          </div>
          <div class="form-group">
            <label>{{ 'ticket.heading' | translate }}</label>
            <p>{{prevList.ticket.heading}}</p>
          </div>
          <div class="form-group">
            <label>{{ 'ticket.latestTicketStatus' | translate }}</label>
            <p>{{prevList.ticket.latestTicketStatus}}</p>
          </div>
          <div class="form-group">
            <label>{{ 'ticket.createdDate' | translate }}</label>
            <p>{{prevList.ticket.createdDate | date}}</p>
          </div>
        </div>

      </div>


      <div class="modal-footer" hidden="true">
        <button type="button" id="closeModalButton12" class="btn btn-secondary" data-dismiss="modal"
          class="btn btn-secondary">{{ 'generic.cancel' | translate }}</button>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="ticket" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'task.headings.add' | translate }}
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">

        <div [formGroup]="Taskform">
          <div class="row">

            <!-- <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>Task Name</label>
                <input formControlName="name" type="text" class="form-control">
              </div>
            </div> -->

            <div class="col-md-12 col-lg-12">
              <div class="col-md-12 col-12" style="padding: 0">
                <div class="form-group">
                  <label>{{ 'task.name' | translate }}</label>
                  <input formControlName="name" type="text" class="form-control">
                </div>
              </div>
              <!-- <div class="col-md-1 col-1 task-button">
                <div class="form-group">
                  <svg xmlns="http://www.w3.org/2000/svg" data-toggle="modal" data-target="#taskspopup" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                  </svg>
                </div>
              </div> -->
            </div>



            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>{{ 'task.description' | translate }}</label>
                <textarea name="" formControlName="description" id="" style="height: 70px" class="form-control"
                  cols="30" rows="10"></textarea>
              </div>
            </div>


            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>{{ 'task.assignTo' | translate }}</label>
                <select class="form-control" formControlName="assignedTo">
                  <option *ngFor="let user of usersWithoutCustomers" [value]="user.userId">{{user.userName}}</option>
                </select>
              </div>
            </div>

            <div class="col-md-6 col-lg-6">
              <div class="form-group ">
                <label>{{ 'task.tagUsers' | translate }}</label>
                <ng-multiselect-dropdown [placeholder]="'tag users'" [ngModelOptions]="{standalone: true}"
                  [settings]="tagUsersdropdownSettings" [data]="tagUsersdropdownList"
                  [(ngModel)]="tagUsersselectedItems" class="form-control" style="padding: 0;border: none"
                  (onSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)">
                </ng-multiselect-dropdown>
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>{{ 'task.taskExpStartDate' | translate }}</label>
                <input formControlName="taskExpStartDate" type="date" class="form-control">
              </div>
            </div>

            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>{{ 'task.taskExpEndDate' | translate }}</label>
                <input formControlName="taskExpEndDate" type="date" class="form-control">
              </div>
            </div>



          </div>


          <div class="col-lg-12" hidden="true">
            <label class="image-upload-container btn btn-bwm">
              <!-- <span>Select Image</span> -->
              <input #imageInput type="file" id="add-image-btn" accept="image/*" hidden="true"
                (change)="onSelectFile($event)">
            </label>
          </div>
          <div class=" media-content">
            <div class="mr-2 image-btn" (click)="addImageBtn()">
              <span>+ {{ 'task.addImage' | translate }}</span>
            </div>
            <div class="media-area"
              style="border: 1px solid #e5e5e5;border-radius: 5px;height: 80px;width: 100px;overflow: hidden;padding: 1px;"
              *ngFor="let image of images" class="mr-2">
              <img src="{{image}}" width="98px" height="78px" style="border-radius: 5px;" alt="" srcset="">
            </div>
          </div>

          <div class="" style="margin: 0;padding: 0;" hidden="true">
            <label class="image-upload-container btn btn-bwm">
              <!-- <span>Select video</span> -->
              <input #imageInput type="file" id="add-video-btn" accept="video/*" hidden="true"
                (change)="onSelectFile($event)">
            </label>
          </div>
          <div class=" media-content">
            <div class="mr-2 image-btn" (click)="addVideoBtn()">
              <span>+ {{ 'task.addVideo' | translate }}</span>
            </div>
            <div class="media-area"
              style="border: 1px solid #e5e5e5;border-radius: 5px;overflow: hidden;height: 80px;width: 100px;padding:1px;"
              *ngFor="let video of videos" class="mr-2">
              <video src="{{video}}" width="98px" height="78px" style="border-radius: 5px;" controls></video> <br />
            </div>
          </div>

          <div class="" style="margin: 0;padding: 0;" hidden="true">
            <label class="image-upload-container btn btn-bwm">
              <!-- <span>Select video</span> -->
              <input #imageInput type="file" id="add-audio-btn" accept="audio/*" hidden="true"
                (change)="onSelectFile($event)">
            </label>
          </div>
          <div class=" media-content">
            <div class="mr-2 image-btn" (click)="addAudioBtn()">
              <span>+ {{ 'task.addAudio' | translate }}</span>
            </div>
            <div class="media-area"
              style="border: 1px solid #e5e5e5;border-radius: 5px;overflow: hidden;height: 80px;width: 100px;padding:1px;"
              *ngFor="let video of videos" class="mr-2">
              <video src="{{video}}" width="98px" height="78px" style="border-radius: 5px;" controls></video> <br />
            </div>
          </div>

          <div *ngFor="let audio of audios" class="mr-2">
            <audio controls>
              <source src="{{audio}}" type="audio/mpeg">
            </audio>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton3" (click)="cancelModel()" class="btn btn-secondary"
            data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
          <button type="button" (click)="addTicketTask()" *ngIf="addTaskButton" class="btn btn-primary">{{
            'task.headings.add' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="taskAddModel" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="task-content">
        <div class="c-button">
          <div class="c-right">
            <h4>Tasks</h4>
          </div>
          <div style="align-items: center;">
            <svg xmlns="http://www.w3.org/2000/svg" style="margin-left: 10px" data-dismiss="modal" width="26"
              height="26" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
              <path
                d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
            </svg>
          </div>
        </div>
        <div class="task-data">
          <div class="task-table" *ngFor="let task of taskMasters;let j = index">
            <ul>
              <li>{{task.taskGroupName}}</li>

              <li style="width: 15%;display: flex;justify-content: space-between;">
                <button (click)="addTaskMaster(j)" class="task-add-button">Add Task</button>
                <a (click)="addc(j+999)"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                    fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                      d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
                  </svg>
                </a>
              </li>
            </ul>
            <div class="dropdown-data" id="{{j+999}}">
              <div class="assignedToAndTags">
                <div class="status-table">
                  <table class="table">
                    <thead>
                      <tr>
                        <th style="width: 20%;">SeqNo</th>
                        <th style="width: 20%;">Name</th>
                        <th style="width: 60%;">Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let taskGroup of task.taskGroup;">
                        <td>{{taskGroup.seqNo}}</td>
                        <td>{{taskGroup.name}}</td>
                        <td>{{taskGroup.description}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton5" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="taskspopup" tabindex="-1" data-backdrop="static" aria-labelledby="taskspopup"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Tasks
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div class="status-table">
          <table class="table">
            <thead>
              <tr>
                <th style="width: 20%;">Task SlNo</th>
                <th style="width: 20%;">Task Name</th>
                <th style="width: 40%;">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let task of TaskNameAndDescription" (click)="autoFill(task.name,task.description)">
                <td>{{task.seqNo}}</td>
                <td>{{task.name}}</td>
                <td>{{task.description}}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="modal-footer">
          <button type="button" id="closeModalButton67" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="assigntaskspopup" tabindex="-1" data-backdrop="static" aria-labelledby="assigntaskspopup"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Assign Task</h5>
      </div>
      <div class="modal-body" style="height: fit-content;">
        <div>
          <select name="" id="" class="form-control" [(ngModel)]="userId">
            <option [value]="user.userId" *ngFor="let user of usersWithoutCustomers">{{user.userName}}
              ({{user.userType.replace("_", " ")}})</option>
          </select>
        </div>

        <div class="modal-footer">
          <button type="button" id="closeTaskAssign" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button type="button" id="closeModalButton67" class="btn btn-primary"
            (click)="taskAssignToUser()">Submit</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteModalLabel">{{ 'generic.confirmation' | translate }}
          <span data-dismiss="modal">
            <i class="bi bi-x-lg" (click)="clearData()"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <p>{{ 'generic.deleteText' | translate }} <span class="delete-span">“{{recordName}} (ID: {{recordId}})”</span>?
        </p>
        <div class="modal-footer">
          <button type="button" id="closeModalDelete" (click)="clearData()" class="btn btn-secondary"
            data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
          <button type="button" (click)="delTicketController()" class="btn btn-primary">{{ 'generic.delete' | translate
            }}</button>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="noteImageView" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Image
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div class="noteImageView">
          <img src="{{noteImageView}}" alt="">
        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>